/**
 * [INPUT]: 依赖 ../scorer 的 ScoreReport 与 DiagnoseRequest / DiagnoseMetrics / GeoMetricKey
 * [OUTPUT]: 对外提供 buildDiagnosePayload(ScoreReport) → DiagnoseRequest
 * [POS]: apps/web/report 的脱敏序列化层，把端侧评分结果裁剪为可发后端的纯数值请求体；docs §3.2
 * [PROTOCOL]: 变更时更新此头部，然后检查 ../../CLAUDE.md
 *
 * 不变量（隐私契约）：
 * - 输出**仅含** 6 顶层字段 + 8 指标，全部为无量纲数值/枚举；
 * - **绝不**携带 landmarks、像素坐标、图像或任何可还原人脸的数据；
 * - base_score = report.total（0–8）；confidence 直传。
 */
import type { DiagnoseMetrics, DiagnoseRequest, GeoMetricKey, ScoreReport } from '../scorer'

/** 8 指标的固定键序，用于断言完整性（与 GeoMetricKey 同源）。 */
const METRIC_KEYS: readonly GeoMetricKey[] = [
  'facial_thirds',
  'midface_ratio',
  'canthal_tilt',
  'interpupillary',
  'gonial_angle',
  'bigonial_bizy',
  'symmetry_index',
  'jaw_sharpness',
]

/**
 * 把端侧 ScoreReport 裁剪为脱敏诊断请求体。
 * 仅抽取分数/置信度/性别与 8 维指标，丢弃 landmarks、deltas、tier 等呈现态字段。
 */
export function buildDiagnosePayload(report: ScoreReport): DiagnoseRequest {
  const metrics = report.metrics as Record<string, number>
  const diagnoseMetrics = {} as DiagnoseMetrics
  for (const k of METRIC_KEYS) {
    const v = metrics[k]
    diagnoseMetrics[k] = typeof v === 'number' ? v : 0
  }

  return {
    client_version: report.meta.scorer,
    gender: report.meta.gender,
    gender_source: report.meta.gender_source,
    base_score: report.total,
    confidence: report.confidence,
    metrics: diagnoseMetrics,
  }
}